const faqs = [
  {
    q: '6080新视觉影视真的是完全免费的吗？',
    a: '是的，6080新视觉影视平台所有影视资源全部免费观看，无需付费、无需开通会员。我们通过技术优化降低运营成本，坚持为用户提供纯净免费的观影体验。',
  },
  {
    q: '需要注册账号才能观看吗？',
    a: '不需要。打开网站即可直接观看所有内容，无需注册、无需登录。我们相信好的服务应该零门槛，让每位用户都能轻松享受观影乐趣。',
  },
  {
    q: '支持哪些设备观看？画质如何？',
    a: '支持电脑、平板、手机等多种设备观看，页面自适应屏幕尺寸。提供高清1080P画质，智能码率自适应技术确保不同网络环境下都能流畅播放。',
  },
  {
    q: '资源多久更新一次？能看到最新剧集吗？',
    a: '我们每日同步更新最新影视资源，热门剧集通常在播出后数小时内上线。同时也会及时补充经典老片和新发现的优质内容，确保片库不断丰富。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于平台的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200"
            >
              <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 text-xs font-bold mt-0.5">Q</span>
                {faq.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 text-xs font-bold mt-0.5">A</span>
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}